import TabsNav from "../../../navigation/tabsNav";
import "./dataMapper.css";

const DataMapper = () => {
    return <TabsNav />
}

export default DataMapper;